import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Close from "@mui/icons-material/Close";
import { EditIcon } from "../../../comps/CustomIcons";

import {
  CheckBox,
  CheckBoxOutlineBlank,
  SettingsOutlined,
} from "@mui/icons-material";
import { DOCTORS_UNIT_SETTING } from "../../../_mock/mock";
const headLabel = [
  {
    id: 1,
    label: "Group",
    value: "group",
  },
  {
    id: 2,
    label: "Doctor",
    value: "doctor",
  },
  {
    id: 3,
    label: "",
    value: "",
  },
];
const UNIT_SETTING_BODY_DATA = [
  {
    group: "ENT",
    doctor: [
      "Dr. Kamal Jain",
      "Dr. John Doe",
      "Dr. John Doe12",
      "Dr. John Doe987",
    ],
  },
];

export default function UnitSettingModal({ open, onClose }) {
  const [isEditable, setIsEditable] = useState(true);
  const handleClose = () => {
    setIsEditable(true); // Reset isEditable when dialog closes
    onClose(); // Call the existing close function
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            minHeight: "60vh",
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "white",
            borderRadius: "10px",
          },
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "20px",
          }}
        >
          <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
            {isEditable ? "Add User" : "Edit Doctor Group"}
          </Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
        <Box component="form">
          <Box
            sx={{
              border: "1px solid rgba(204, 212, 218, 1)",
              p: "15px",
              borderRadius: "8px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField label="Unit Name" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField label="Head of Unit" fullWidth />
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              paddingBlock: "15px",
            }}
          >
            <Typography>Manage User</Typography>
            <Button
              variant="outlined"
              sx={{ textTransform: "none", width: "150px" }}
            >
              Add User
            </Button>
          </Box>
          {/* {isEditable ? (
            <Box>
              <Box
                sx={{
                  bgcolor: "rgba(234, 234, 234, 1)",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  p: "15px",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={5}>
                    <Typography>Group</Typography>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography>Doctor</Typography>
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  border: "1px solid rgba(234, 234, 234, 1)",
                  p: "15px",
                  borderBottomLeftRadius: "12px",
                  borderBottomRightRadius: "12px",
                }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={5}>
                    <Typography>ENT</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={7}
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Box>
                      <Typography>Dr. John Doe</Typography>
                      <Typography>Dr. John Doe</Typography>
                      <Typography>Dr. John Doe</Typography>
                      <Typography>Dr. John Doe</Typography>
                    </Box>
                    <Box>
                      <IconButton onClick={() => setIsEditable(false)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton>
                        <Close />
                      </IconButton>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          ) : (
            <Box>
              <TextField fullWidth label="Group" />
              <Box>
                <Box
                  sx={{
                    bgcolor: "rgba(234, 234, 234, 1)",
                    // borderTopLeftRadius: "12px",
                    // borderTopRightRadius: "12px",
                    p: "15px",
                    marginTop: "15px",
                  }}
                >
                  <Typography>Doctor</Typography>
                </Box>
                <Box
                  sx={{
                    border: "1px solid rgba(234, 234, 234, 1)",
                    p: "15px",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                >
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    // limitTags={1}
                    options={DOCTORS_UNIT_SETTING || []}
                    getOptionLabel={(option) => option?.doctorName || ""} // it is necessary for searching the options
                    renderInput={(params) => (
                      <TextField {...params} label="Doctor" fullWidth />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={<CheckBoxOutlineBlank fontSize="small" />}
                          checkedIcon={<CheckBox fontSize="small" />}
                          checked={selected}
                          sx={{ mr: 1 }}
                        />
                        {option?.doctorName || ""}
                      </li>
                    )}
                    renderTags={(selected, getTagProps) =>
                      selected?.map((option, index) => (
                        <Chip
                          label={option?.doctorName}
                          size="small"
                          {...getTagProps({ index })}
                          key={option?.id}
                        />
                      ))
                    }
                    // value={selectedOptions || []}
                    // onChange={handleSelectionChange}
                    sx={{ minWidth: "200px" }}
                  />
                </Box>
              </Box>
            </Box>
          )} */}
          {!isEditable && (
            <Box sx={{ p: "15px" }}>
              <TextField label="Group" fullWidth />
            </Box>
          )}
          <TableContainer component={Paper}>
            <Table aria-label="nursing table" sx={{ minWidth: 800 }}>
              <TableHead
                sx={{
                  backgroundColor: "#f5f5f5",
                  "& th": { fontWeight: "bold" },
                }}
              >
                {isEditable ? (
                  <TableRow>
                    {headLabel?.map((option) => (
                      <TableCell
                        key={option?.id}
                        sx={{ textAlign: option?.align || "left" }}
                      >
                        {option?.label}
                      </TableCell>
                    ))}
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell>Doctor</TableCell>
                  </TableRow>
                )}
              </TableHead>
              {isEditable ? (
                <TableBody>
                  {UNIT_SETTING_BODY_DATA?.map((row) => (
                    <TableRow key={row?.uhid}>
                      {headLabel?.map((column, index) =>
                        index !== headLabel?.length - 1 ? (
                          <TableCell key={column?.id}>
                            {column?.value === "doctor"
                              ? row[column?.value]?.map((doctor, i) => (
                                  <Typography key={i} sx={{ display: "block" }}>
                                    {doctor}
                                  </Typography>
                                ))
                              : row[column?.value]}
                          </TableCell>
                        ) : (
                          <TableCell
                            key={column?.id}
                            sx={{ textAlign: "right" }}
                          >
                            <IconButton>
                              <EditIcon
                                sx={{
                                  cursor: "pointer",
                                  color: "transparent",
                                  fontSize: "18px",
                                }}
                                onClick={() => setIsEditable(false)}
                              />
                            </IconButton>
                            <IconButton>
                              <SettingsOutlined
                                sx={{
                                  cursor: "pointer",
                                  fontSize: "18px",
                                  ml: 1,
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <Autocomplete
                        multiple
                        disableCloseOnSelect
                        // limitTags={1}
                        options={DOCTORS_UNIT_SETTING || []}
                        getOptionLabel={(option) => option?.doctorName || ""} // it is necessary for searching the options
                        renderInput={(params) => (
                          <TextField {...params} label="Doctor" fullWidth />
                        )}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={<CheckBoxOutlineBlank fontSize="small" />}
                              checkedIcon={<CheckBox fontSize="small" />}
                              checked={selected}
                              sx={{ mr: 1 }}
                            />
                            {option?.doctorName || ""}
                          </li>
                        )}
                        renderTags={(selected, getTagProps) =>
                          selected?.map((option, index) => (
                            <Chip
                              label={option?.doctorName}
                              size="small"
                              {...getTagProps({ index })}
                              key={option?.id}
                            />
                          ))
                        }
                        // value={selectedOptions || []}
                        // onChange={handleSelectionChange}
                        sx={{ minWidth: "200px" }}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
